/**
 * Dashboard container file
 *
 * @package    src/containers
 * @author     YingTuring <ying@turing.com>
 * @copyright  2018 Turing Company
 * @license    Turing License
 * @version    2.0
 * @link       https://turing.ly/dashboard
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import DashboardWrapper from '../../components/Dashboard/Wrapper/DashboardWrapper';
import AuthActions from '../../actions/Auth';
import * as service from '../../services/Auth';
import { pushLog2DV2LogServer } from '../../services/logging';
import { StatusConstant, ApiConstant, ActionConstant, PageConstant } from '../../constants';
import DashboardRoutesArray from '../../routes/DashboardRoutes';
import dashboardStyle from '../../../assets/jss/dashboard/dashboardStyle';
import { Layout } from 'antd';
// import NavigationDrawer from '../../components/NavigationDrawer/NavigationDrawer';
import NavigationDrawer from '../../components/NavigationDrawer/NavigationDrawer';
import LayoutContainer from './Layout';
import { turingLogger } from '../../shared/TuringLogger';
// import { checkBasicChallengesPassed } from '../../legacy_components/components/admin/ChallengeList/services';
// When logedin Notification modal - disabled/hidden on 2019-09-11
//import AfterLogInNotification from '../../components/Common/AfterLogInNotification'
// MainMenu and All Apps structures

/**
 * Dashboard container class
 *
 * This class will be contains all of the components for dashboard
 *
 * @category  Container
 * @author    yingTuring <ying@turing.com>
 */
class DashboardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      isMobileClass: 'is-not-mobile',
      logoutClicked: false,
      updateSidebar: false,
      announcement: null,
      userIsAvailable: undefined,
      availabilityObj: {},
      availabilityUpdated: false
    };
    this.dashboardRoutes = [...DashboardRoutesArray];
  }

  /**
  * Life cycle API that is invoked immediately after a component is mounted
  */
  componentDidMount() {
    window.addEventListener("resize", this.resizeFunction);

  }

  /**
   * Life cycle API that is invoked immediately that a component is updated
   */
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      const { authenticated } = this.props;
      if (authenticated)
        if (this.refs.mainPanel) {
          this.refs.mainPanel.scrollTop = 0;
        }
      if (this.state.mobileOpen) {
        this.setState({
          mobileOpen: false,
          isMobileClass: 'is-not-mobile'
        });
      }
    }
  }
  /**
   * Life cycle API that is invoked immediately before a component is unmounted
   */
  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeFunction);
  }

  toggleUpdateSidebar = () => {
    this.setState(ps => ({
      updateSidebar: !ps.updateSidebar
    }));
  }

  handleUserIsAvailableChange = (availability, availabilityObj={}, availabilityUpdated=false) => {
    this.setState({ userIsAvailable: availability, availabilityObj, availabilityUpdated });
    this.props.dispatch({ type: ActionConstant.SAVE_AVAILABILITY_TO_STORE, payload: availabilityObj })
  }
  /**
   * Handle function when drawer is toggled
   */
  handleDrawerToggle = () => {
    //this.setState({ mobileOpen: !this.state.mobileOpen })
    //this.setState({ mobileOpen: true })
    //console.log("toogle menu on mobile: " + this.state.mobileOpen)
    if (this.state.mobileOpen === true) {
      this.setState({
        mobileOpen: false,
        isMobileClass: 'is-not-mobile'
      });
    } else {
      this.setState({
        mobileOpen: true,
        isMobileClass: 'is-mobile'
      });
    }
  };

  /**
   * Resize function for mobile
   */
  resizeFunction = () => {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  }

  /**
   * Function that log out
   */
  handleLogout = () => {
    const { authenticate } = this.props;
    let param = {
      status: StatusConstant.LOGOUT
    };

    let promiseObj = service.logout(param);

    promiseObj.then(() => {
      localStorage.clear();

      authenticate({
        authenticated: false,
      });
    }).catch(error => {
      console.log(error);
      // [LOGGING] - SIGN_OUT
      pushLog2DV2LogServer.error('USER_LOGGING', 'SIGN_OUT', {}, {}, error);
      turingLogger.error({ eventName: 'SIGNOUT_ERR', logData: { error } }).catch(e => console.error(e));
    });
    // [LOGGING] - SIGN_OUT
    pushLog2DV2LogServer.info('USER_LOGGING', 'SIGN_OUT', {}, {}, null);
    turingLogger.log({ eventName: 'SIGNOUT', logData: {} }).catch(e => console.error(e));
    turingLogger.removeIdentity().catch(e => console.error(e));
  }

  switchRoutes = (toggleUpdateSidebar, dashboardRoutes) => (
    <Switch>
      {dashboardRoutes.map((prop, key) => {
        if (Object.keys(this.props.match.params).length > 0) {
          let path = `${prop.path}`;
          Object.keys(this.props.match.params).map(param => {
            path = path + `/:${param}`;
          });
          return <Route path={path} render={(props) => <prop.component {...props} updateSidebar={toggleUpdateSidebar} userIsAvailable={this.state.userIsAvailable} handleUserIsAvailableChange={this.handleUserIsAvailableChange} />} key={key}  />;
        }
        return <Route path={prop.path} render={(props) => <prop.component {...props} updateSidebar={toggleUpdateSidebar} userIsAvailable={this.state.userIsAvailable} handleUserIsAvailableChange={this.handleUserIsAvailableChange} />} key={key} />;
      })}
    </Switch>
  )

  /**
   * Render function to view this component
   */
  render() {
    const { path } = this.props.match;
    const { classes, authenticated, ...rest } = this.props;
    // if logout button clicked, redirect to login page
    const localAuthenticated = localStorage.getItem('authenticated');
    const login_redirect = localStorage.getItem('login_redirect');
    if (!localAuthenticated)
      return <Redirect to="/login" />;
    return (
      <div key="/test">
        
        <DashboardWrapper>
          <Layout className="mainLayout">
            <NavigationDrawer
              menuItems={this.dashboardRoutes}
              isMobileClass={this.state.isMobileClass}
              updateSidebar={this.state.updateSidebar}
              toggleUpdateSidebar={this.toggleUpdateSidebar}
              handleDrawerToggle={this.handleDrawerToggle}
            />
            {/* <DashboardHeader
              routes={this.dashboardRoutes}
              handleDrawerToggle={this.handleDrawerToggle}
              {...rest}
            /> */}
            <LayoutContainer
              path={path}
              className="mainLayout"
              routes={this.dashboardRoutes}
              handleDrawerToggle={this.handleDrawerToggle}
              history={this.props.history}
            >
              <div className={classes.container}>{this.switchRoutes(this.toggleUpdateSidebar, this.dashboardRoutes)}</div>
            </LayoutContainer>
          </Layout>
        </DashboardWrapper>
      </div>
    );
  }
}

DashboardContainer.propTypes = {
  classes: PropTypes.object.isRequired,
  authenticated: PropTypes.bool.isRequired,
  authenticate: PropTypes.func.isRequired,
  match: PropTypes.object
};

const mapStateToProps = (state) => {
  return { ...state.auth };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    authenticate: payload => dispatch(AuthActions.authenticate(payload)),
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(dashboardStyle)(DashboardContainer));
